import { createSelector } from "reselect";

import { getDisplayPrice } from "@app/helpers/udm/get-display-price";

import { getTripById } from "./get-trip";
import { getDisplayedPriceConfig } from "../get-displayed-price-config";

export const getTripDisplayPrice = createSelector(
  [getTripById, getDisplayedPriceConfig],
  (trip, displayed_price_config) =>
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    getDisplayPrice(trip, "trip", displayed_price_config)
);
